import { Swiper } from "swiper"
import anime from "animejs"

const historySliders = [...document.querySelectorAll('.js-historySlider')]

if (historySliders.length) {
    historySliders.forEach(historySlider => {
        const historySliderPrevious = historySlider.querySelector('.js-historySliderPrevious')
        const historySliderNext = historySlider.querySelector('.js-historySliderNext')
        const historySliderContainer = historySlider.querySelector('.js-historySliderContainer')
        const historySliderYear = historySlider.querySelector('.js-historySliderYear')
        const historyThumbnails = [...historySlider.querySelectorAll('.js-thumbnail')]

        const swiper = new Swiper(historySliderContainer, {
            effect: 'fade',
            loop: true,
            autoHeight: true,
            fadeEffect: {
              crossFade: true
            },
        })

        historyThumbnails.forEach(thumbnail => {
            const thumbnailIndex = thumbnail.dataset.thumbnailIndex * 1

            thumbnail.addEventListener('click', () => {
                swiper.slideTo(thumbnailIndex + 1)
            })

            // Removing tabbing so only the previous and next buttons are presented to screenreaders
            thumbnail.tabIndex = -1
        })

        historySliderPrevious.addEventListener('click', () => { swiper.slidePrev() })
        historySliderNext.addEventListener('click', () => { swiper.slideNext() })

        swiper.on('slideChange', (instance) => {
            const { realIndex } = instance
            const slideElement = historySlider.querySelector(`[data-slide-index="${realIndex}"]`)
            const currentThumbnail = historySlider.querySelector(`[data-thumbnail-index="${realIndex}"]`)
            const year = slideElement.dataset.year * 1
            const animateObject = { a: historySliderYear.textContent * 1 }

            historyThumbnails.forEach(thumbnail => thumbnail.classList.remove('-active'))
            currentThumbnail.classList.add('-active')

            anime({
                targets: animateObject,
                a: year,
                easing: 'linear',
                round: 1,
                update() {
                    historySliderYear.textContent = animateObject.a
                }
            })
        })
    })
}